import { IGenesysFile } from "../interface/IMessage";
import isIGenesysFile from "./isIGenesysFile";

export default function getFileSize(uploadFile: IGenesysFile | File): number {
  if (isIGenesysFile(uploadFile)) {
    return uploadFile.fileSize;
  } else {
    return uploadFile.size;
  }
}

export const getFormattedFileSize = (fileSize: number): string => {
  return fileSize < 1024
    ? `${fileSize} B`
    : fileSize < 1024 * 1024
    ? `${Math.round(fileSize / 1024)} KB`
    : `${Math.round(fileSize / (1024 * 1024))} MB`;
};
